import { PremierServiceDTO } from "../DTO/premierServiceDTO";
import { PremierServiceProduct } from "./premierServiceProduct";

export class PremierService{
    public id!: number;
    public partnerId!: number;
    public name!: string;
    public serviceTypeId!: string;
    public status!: number; // 0 = Inactive, 1 = Active
    public enabled!: boolean;
    public parameterTemplate!: IServiceParameter[]; //json template to define what parameters need to be provided to consume the partner service
    public productsList!: PremierServiceProduct[];
    public added!: Date;
    public edited!: Date;

    constructor(){
        this.productsList= new Array();
    }

    public initialize(){
        
    }

    public static mapFromDTO(param:PremierServiceDTO):PremierService{
        if(!param) throw new Error("parameter is null");
        let obj = new PremierService();
        try
        {
            obj.id = param.id;
            obj.partnerId = param.partnerId;
            obj.name = param.name;
            obj.serviceTypeId = param.serviceTypeId;
            obj.status = param.status;
            obj.enabled = param.enabled;
            if(param.parameterTemplate) obj.parameterTemplate = JSON.parse(param.parameterTemplate);
            if(param.productList) obj.productsList= param.productList.map(psp=>PremierServiceProduct.mapFromDTO(psp));
            if(param.added) obj.added = new Date(param.added);
            if(param.edited) obj.edited = new Date(param.edited);
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param:PremierService):PremierServiceDTO{
        if(!param) throw new Error("parameter is null");
        let dto = new PremierServiceDTO();
        try
        {
            dto.id = param.id;
            dto.partnerId = param.partnerId;
            dto.name = param.name;
            dto.serviceTypeId = param.serviceTypeId;
            dto.status = param.status;
            dto.enabled = param.enabled;
            dto.parameterTemplate = JSON.stringify(param.parameterTemplate);
            if(dto.productList) dto.productList = param.productsList.map(psp=>PremierServiceProduct.mapToDTO(psp));
            if(dto.added) dto.added = param.added.toISOString();
            if(dto.edited) dto.edited = param.edited.toISOString();
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }

    get displayStatus():string{
        switch(this.status){
            case 0:
                return "Inactive";
            case 1:
                return "Active";
            default:
                return "Unknown";
        }
    }
}

export interface IServiceParameterOption{
    id:number,
    label:string,
    parameters:IServiceParameter[];
}

export interface IServiceParameter{
    label:string;
    name:string;
    inputType:string; //possible values are: slt=single line text, mlt=multi line text, sel=selection, num=numeric, eml=email
    mandatory:boolean;
}